import React from 'react'
import { useSelector } from 'react-redux';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { userSelector } from 'slices/userSlice';
import ForgotPassword from 'views/ForgotPassword';

import Login from "views/login";
import Register from "views/register";
import ResetPassword from 'views/ResetPassword';
export const AuthRoutes = () => {
    const { pathname } = useLocation()
    const { isAuthenticated } = useSelector(userSelector);

    // Redirect to admin if already authenticated
    // if (isAuthenticated) {
    //     return <Navigate to="/admin" replace />;
    // }
    return (
        <Routes>
            <Route path="/login" element={<Login />} />
            {/* <Route path="/register" element={<Register />} /> */}
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            {/* Catch-all for unauthenticated users */}
            {pathname !== "/interview-invite" && <Route path={"*"} element={<Navigate to="/login" replace />} />}
        </Routes>
    )
}
